export function Footer() {
    return (
        <footer id="contact" className="py-5 bg-gray-800 text-white">
            <div className="container mx-auto px-4">
                <div className="max-w-6xl mx-auto">
                    <div className="text-center">
                        <p className="text-gray-400 text-sm">
                            © 2026 KONASPI XII - Universitas Pendidikan Ganesha. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
